import { render, staticRenderFns } from "./ServiceRegOld.vue?vue&type=template&id=8d543552&scoped=true"
import script from "./ServiceRegOld.vue?vue&type=script&lang=js"
export * from "./ServiceRegOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d543552",
  null
  
)

export default component.exports